import ConfirmDraftsMoveModal from './ConfirmDraftsMoveModal'

export default ConfirmDraftsMoveModal
